import BikeOverviewContainer from '@/components/containers/pdp/overview/bike/BikeOverviewContainer.vue';
import AftermarketOverviewContainer from '@/components/containers/pdp/overview/aftermarket/AftermarketOverviewContainer.vue';

export {BikeOverviewContainer, AftermarketOverviewContainer};
